import { ColDef } from 'ag-grid-community';

export type ProductRow = {
    productId: number;
    productName: string;
    productCategory1Id?: number;
    productCategory2Id?: number;
    productCategory1Name?: string;
    productCategory2Name?: string;
    productGroupId?: number;
    productGroupName?: string;
    sortOrder?: string;
    customAttribute1?: string;
    hidePrices: boolean;
    netWeight: number;
    grossWeight: number;
    conversionFactor?: number;
    countryOfOrigin?: string;
    priceUnit?: string;
    vat?: number;
    boxesPerPallet?: number;
    palletType?: number;
};

export const productInitialColDefs: ColDef<ProductRow>[] = [
    {
        field: 'hidePrices',
        headerName: 'Hide prices',
        width: 92
    },
    {
        field: 'productId',
        headerName: 'Product id',
        width: 100
    },
    {
        field: 'productName',
        headerName: 'Product name',
        width: 300
    },
    {
        field: 'productCategory1Id',
        headerName: 'Product category 1',
        width: 160,
        editable: false
    },
    {
        field: 'productCategory2Id',
        headerName: 'Product category 2',
        width: 160,
        editable: false
    },
    {
        field: 'productGroupId',
        headerName: 'Product group',
        width: 180,
        editable: false
    },
    {
        field: 'sortOrder',
        headerName: 'Sort order',
        width: 180,
        editable: false
    },
    {
        field: 'netWeight',
        headerName: 'Net weight',
        width: 120
    },
    { field: 'grossWeight', headerName: 'Gross weight', width: 120 },
    {
        field: 'conversionFactor',
        headerName: 'Conversion factor',
        width: 120
        // formatter: NumberFormatter
    },
    { field: 'countryOfOrigin', headerName: 'Country', width: 80 },
    { field: 'priceUnit', headerName: 'Price unit', width: 120 },
    { field: 'vat', headerName: 'Vat (%)', width: 120 },
    {
        field: 'customAttribute1',
        headerName: 'EMV',
        width: 60
    },
    {
        field: 'boxesPerPallet',
        headerName: 'Boxes Per Pallet',
        width: 60
    },
    {
        field: 'palletType',
        headerName: 'Pallet type',
        width: 60
    }
];
